/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Allocation_SettingsInputs */

const en_admin_resources_allocation_settings = /** @type {(inputs: Admin_Resources_Allocation_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocation Settings`)
};

const de_admin_resources_allocation_settings = /** @type {(inputs: Admin_Resources_Allocation_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuweisungs-Einstellungen`)
};

const es_admin_resources_allocation_settings = /** @type {(inputs: Admin_Resources_Allocation_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustes de asignación`)
};

const fr_admin_resources_allocation_settings = /** @type {(inputs: Admin_Resources_Allocation_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres d'attribution`)
};

/** @type {(inputs: Admin_Resources_Allocation_SettingsInputs) => LocalizedString} */
const it_admin_resources_allocation_settings = en_admin_resources_allocation_settings;

/** @type {(inputs: Admin_Resources_Allocation_SettingsInputs) => LocalizedString} */
const pt_br2_admin_resources_allocation_settings = en_admin_resources_allocation_settings;

/** @type {(inputs: Admin_Resources_Allocation_SettingsInputs) => LocalizedString} */
const pl_admin_resources_allocation_settings = en_admin_resources_allocation_settings;

/** @type {(inputs: Admin_Resources_Allocation_SettingsInputs) => LocalizedString} */
const hu_admin_resources_allocation_settings = en_admin_resources_allocation_settings;

/** @type {(inputs: Admin_Resources_Allocation_SettingsInputs) => LocalizedString} */
const ro_admin_resources_allocation_settings = en_admin_resources_allocation_settings;

/**
* | output |
* | --- |
* | "Allocation Settings" |
*
* @param {Admin_Resources_Allocation_SettingsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_allocation_settings = /** @type {((inputs?: Admin_Resources_Allocation_SettingsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Allocation_SettingsInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_allocation_settings(inputs)
	if (locale === "de") return de_admin_resources_allocation_settings(inputs)
	if (locale === "es") return es_admin_resources_allocation_settings(inputs)
	if (locale === "fr") return fr_admin_resources_allocation_settings(inputs)
	if (locale === "it") return it_admin_resources_allocation_settings(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_allocation_settings(inputs)
	if (locale === "pl") return pl_admin_resources_allocation_settings(inputs)
	if (locale === "hu") return hu_admin_resources_allocation_settings(inputs)
	return ro_admin_resources_allocation_settings(inputs)
});
export { admin_resources_allocation_settings as "admin.resources.allocation_settings" }